import { render, staticRenderFns } from "./ManuscriptSettingsDialog.vue?vue&type=template&id=1adc01a8&scoped=true"
import script from "./ManuscriptSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptSettingsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptSettingsDialog.vue?vue&type=style&index=0&id=1adc01a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc01a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1adc01a8')) {
      api.createRecord('1adc01a8', component.options)
    } else {
      api.reload('1adc01a8', component.options)
    }
    module.hot.accept("./ManuscriptSettingsDialog.vue?vue&type=template&id=1adc01a8&scoped=true", function () {
      api.rerender('1adc01a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/ManuscriptSettingsDialog.vue"
export default component.exports